export default __webpack_public_path__ + "static/media/Shadayev_Maksut_Igorevich.a2b595b7.webp";